// Work around for hydration issues from external scripts modifying the DOM.  There is likely a better way to handle this.

import { useEffect } from 'react'

let scriptsAdded = false

export const CustomExternalScripts = () => {
  useEffect(() => {
    if (scriptsAdded) return

    scriptsAdded = true
  }, [])

  return null
}
